import { apiRequest } from '@/api/apiClient/base';
import type { Identity } from '@/api/apiClient/users';

/**
 * Exchange a Firebase ID token for a registrar session. POSTs `{ idToken }` to
 * `/api/auth/session`; the server verifies the token, provisions/looks-up the
 * Firebase-owned profile, sets the HttpOnly `nori_session` cookie, and returns
 * the acting identity. The `firebase` SDK that mints the ID token stays at the
 * edge — this seam only takes the string. Rejects with an `ApiError` when the
 * token cannot be verified (401) or Firebase sign-in is not configured (404).
 */
export function exchangeFirebaseToken(idToken: string): Promise<Identity> {
  return apiRequest<Identity>('/api/auth/session', {
    method: 'POST',
    body: { idToken },
  });
}
